const token = localStorage.getItem('token')
async function apiRequest(url, method, data, clientToken) {
  try {
    const token = localStorage.getItem("token"); 
    const isFormData = data instanceof FormData;
    const headers = {
      Authorization: `Bearer ${clientToken || token}`,
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    };
    const response = await fetch(url, {
      method,
      headers,
      body: method === 'GET' ? undefined : isFormData ? data : JSON.stringify(data),
    });
    const result = await response.json();
    if (response.ok) {
      return { success: true, statusCode: response?.status, data: result };
    } else {
      return {
        success: false,
        statusCode: response?.status,
        data: result,
        error: result?.message || "Something went wrong"
      };
    }
  } catch (error) {
    console.error("Request Failed:", error);
    return { success: false, error: "Network error, please try again later" };
  }
}

export default apiRequest;
